export default function ({ i18n, $dayjs }) {
  $dayjs.locale(i18n.locale)
  $dayjs.tz.setDefault('Asia/Dubai')
}
